

// // // import React from 'react';
// // // import { NavLink } from 'react-router-dom';
// // // import { Box, List, ListItemButton, ListItemText, useTheme } from '@mui/material';

// // // const Sidebar = ({ role, isOpen, closeSidebar }) => {
// // //   const theme = useTheme();

// // //   const links =
// // //     role === 'admin'
// // //       ? [
// // //           { to: '/dashboard', label: 'Dashboard' },
// // //           { to: '/add-reporter', label: 'add-reporter' },
          
// // //                { to: '/HeadlinePage', label: 'HeadlinePage' },
               
               
// // //                { to: '/NewsManagement', label: 'NewsManagement' },


                        
// // //                { to: '/reporters', label: 'reporters' },
// // //         ]
// // //       : [
// // //           { to: '/reporter-dashboard', label: 'Dashboard' },
// // //           { to: '/NewsCreationPage', label: 'NewsCreationPage' },


// // //         ];

// // //   return (
// // //     <Box
// // //       sx={{
// // //         width: 220,
// // //         height: '100vh',
// // //        backgroundColor: '#91dfd8ff', // Light Blue background
// // //         color: '#236bcaff', // Dark Blue text
// // //         position: 'fixed',
// // //         top: 0,
// // //         left: 0,
// // //         zIndex: 1200,
// // //         display: { xs: isOpen ? 'block' : 'none', md: 'block' },
    
// // //       }}
// // //     >
// // //       <Box sx={{ p: 2, fontWeight: 'bold', fontSize: 18, borderBottom: `1px solid ${theme.palette.divider}` }}>
// // //         {role === 'admin' ? 'Admin Panel' : 'Reporter Panel'}
// // //       </Box>

// // //       <List>
// // //         {links.map((link) => (
// // //           <NavLink
// // //             key={link.to}
// // //             to={link.to}
// // //             style={{ textDecoration: 'none' }}
// // //             onClick={closeSidebar}
// // //           >
// // //             {({ isActive }) => (
// // //               <ListItemButton
// // //                 selected={isActive}
// // //                 sx={{
// // //                   backgroundColor: isActive ? theme.palette.primary.light : 'transparent',
// // //                   '&:hover': {
// // //                     backgroundColor: theme.palette.action.hover,
// // //                   },
// // //                 }}
// // //               >
// // //                 <ListItemText
// // //                   primary={link.label}
// // //                   sx={{
// // //                     color: isActive ? theme.palette.primary.main : theme.palette.text.primary,
// // //                     fontWeight: isActive ? 'bold' : 'normal',
// // //                   }}
// // //                 />
// // //               </ListItemButton>
// // //             )}
// // //           </NavLink>
// // //         ))}
// // //       </List>
// // //     </Box>
// // //   );
// // // };

// // // export default Sidebar;

// // // updATE BY  8/21/25  BY SUPERADMIN ADD 



// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import { Box, List, ListItemButton, ListItemText, useTheme } from '@mui/material';

// const Sidebar = ({ role, isOpen, closeSidebar }) => {
//   const theme = useTheme();

//   // ✅ Links role ke hisaab se
//   const links =
//     role === 'admin'
//       ? [
//           { to: '/dashboard', label: 'Dashboard' },
//           { to: '/add-reporter', label: 'Add Reporter' },
//                { to: '/HeadlinePage', label: 'HeadlinePage' },
               
//           { to: '/NewsManagement', label: 'News Management' },
//           { to: '/reporters', label: 'Reporters' },
//              { to: '/PollForm', label: 'PollForm' },
             
//               { to: '/PollList', label: 'PollList' },
              
//                  { to: '/VideoManagement', label: 'VideoManagement' },
          
//         ]
//       : role === 'reporter'
//       ? [
//           { to: '/reporter-dashboard', label: 'Dashboard' },
//           { to: '/NewsCreationPage', label: 'Create News' },
//           { to: '/MyNews', label: 'MyNews' },
//           { to: '/CreateShort', label: 'CreateShort' },  
//           { to: '/MyShorts', label: 'MyShorts' },
          
//         ]
//       : role === 'superadmin'
//       ? [
//           { to: '/superadmin-dashboard', label: 'Dashboard' },
//           { to: '/manage-admins', label: 'Manage Admins' },
          
//                  { to: '/Create-admins', label: 'Create-admins' },
        
//         ]
//       : [];

//   return (
//     <Box
//       sx={{
//         width: 220,
//         height: '100vh',
//         backgroundColor: '#91dfd8ff', // Light Blue
//         color: '#236bcaff', // Dark Blue text
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         zIndex: 1200,
//         display: { xs: isOpen ? 'block' : 'none', md: 'block' },
//       }}
//     >
//       {/* ✅ Sidebar Title */}
//       <Box
//         sx={{
//           p: 2,
//           fontWeight: 'bold',
//           fontSize: 18,
//           borderBottom: `1px solid ${theme.palette.divider}`,
//         }}
//       >
//         {role === 'admin'
//           ? 'Admin Panel'
//           : role === 'reporter'
//           ? 'Reporter Panel'
//           : role === 'superadmin'
//           ? 'SuperAdmin Panel'
//           : 'Panel'}
//       </Box>

//       {/* ✅ Sidebar Links */}
//       <List>
//         {links.map((link) => (
//           <NavLink
//             key={link.to}
//             to={link.to}
//             style={{ textDecoration: 'none' }}
//             onClick={closeSidebar}
//           >
//             {({ isActive }) => (
//               <ListItemButton
//                 selected={isActive}
//                 sx={{
//                   backgroundColor: isActive
//                     ? theme.palette.primary.light
//                     : 'transparent',
//                   '&:hover': {
//                     backgroundColor: theme.palette.action.hover,
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary={link.label}
//                   sx={{
//                     color: isActive
//                       ? theme.palette.primary.main
//                       : theme.palette.text.primary,
//                     fontWeight: isActive ? 'bold' : 'normal',
//                   }}
//                 />
//               </ListItemButton>
//             )}
//           </NavLink>
//         ))}
//       </List>
//     </Box>
//   );
// };

// export default Sidebar;

import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  useTheme,
  Drawer,
  Typography,
  Divider,
  IconButton
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  PersonAdd as PersonAddIcon,
  PeopleOutline as PeopleOutlineIcon,
  Article as ArticleIcon,
  Newspaper as NewspaperIcon,

  Poll as PollIcon,
  NoteAdd as NoteAddIcon,
  ListAlt as ListAltIcon,
  Videocam as VideocamIcon,
  AddBox as AddBoxIcon,
  ArticleOutlined as ArticleOutlinedIcon,
  ShortText as ShortTextIcon,
  VideoCall as VideoCallIcon,
  VideoLibrary as VideoLibraryIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  ManageAccounts as ManageAccountsIcon,
  PersonAddAlt1 as PersonAddAlt1Icon,
  PeopleAlt as PeopleAltIcon,
  ExpandLess,
  ExpandMore,
  LocationOn as LocationOnIcon,
  MenuOpen as MenuOpenIcon,
  FolderOpen, // For closing the drawer on mobile
} from '@mui/icons-material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer'; // for tags
import CategoryIcon from "@mui/icons-material/Category";       // Category
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight"; // SubCategory
import { AwardIcon, TagIcon } from 'lucide-react';
import Person from '@mui/icons-material/Person';
// --- SidebarItem Component (for handling nested links and icons) ---
// --- SidebarItem Component ---
const SidebarItem = ({ item, level = 0, closeSidebar, openKey, setOpenKey }) => {
  const theme = useTheme();
  const location = useLocation();

  const isActive = item.to && location.pathname === item.to;

  const handleClick = () => {
    if (item.children) {
      setOpenKey(openKey === item.label ? null : item.label); 
      // agar wahi khula hai to band karo, warna naya khol do
    }
  };

  const isOpen = openKey === item.label;

  const listItemProps = item.to
    ? {
        component: NavLink,
        to: item.to,
        onClick: closeSidebar,
      }
    : { onClick: handleClick };

  return (
    <>
      <ListItemButton
        {...listItemProps}
        sx={{
          minHeight: 48,
          justifyContent: 'initial',
          px: 2.5,
          pl: 2 + level * 2,
          borderRadius: "8px",
          marginX: "8px",
          backgroundColor: isActive ? '#0076b4' : 'transparent',
          color: isActive ? '#fff' : theme.palette.text.primary,
          fontWeight: isActive ? 'bold' : 'normal',
          '& .MuiListItemIcon-root': {
            color: isActive ? '#fff' : theme.palette.text.secondary,
          },
          '&:hover': {
            backgroundColor: '#0076b4',
            color: '#fff',
            '& .MuiListItemIcon-root': { color: '#fff' },
            '& .MuiListItemText-primary': {
              color: '#fff',
              fontWeight: 'bold',
            },
          },
        }}
      >
        {item.icon && (
          <ListItemIcon sx={{ minWidth: 0, mr: item.children ? 1 : 1.5, justifyContent: 'center' }}>
            {item.icon}
          </ListItemIcon>
        )}
        <ListItemText primary={item.label} />
        {item.children && (isOpen ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>

      {item.children && (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((child) => (
              <SidebarItem
                key={child.to || child.label}
                item={child}
                level={level + 1}
                closeSidebar={closeSidebar}
                openKey={openKey}
                setOpenKey={setOpenKey}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

// --- Sidebar Component ---
const Sidebar = ({ role, isOpen, closeSidebar }) => {
  const theme = useTheme();
  const [openKey, setOpenKey] = useState(null);   // ✅ Track which dropdown is open


  // ✅ Links role ke hisaab se with icons and nesting
  const links =




  
    role === 'admin'
      ? [
          { to: '/dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
          {
            label: 'Reporters', // Parent item
            icon: <PeopleIcon />,
            children: [
              { to: '/add-reporter', label: 'Add Reporter', icon: <PersonAddIcon /> },
              { to: '/reporters', label: 'View Reporters', icon: <PeopleOutlineIcon /> },
              {to: '/profile', label: 'Profile', icon: <Person /> },
            ],
          },
          {
            label: 'News Content', // Parent item
            icon: <ArticleIcon />,
            children: [
              // { to: '/NewsManagement', label: 'Manage News', icon: <NewspaperIcon /> },
              { to: '/HeadlinePage', label: 'Headlines', icon: <NewspaperIcon /> },
              { to: '/createNewsbyAdmin', label: 'Create News', icon: <AddBoxIcon /> },
              
                  { to: '/MyNewsAdmin', label: ' MyNews', icon: <AddBoxIcon /> },
                  
                
                  { to: '/AllNewsManagement', label: 'All News', icon: <AddBoxIcon /> }
            ],
          },
          {
            label: 'Polls', // Parent item
            icon: <PollIcon />,
            children: [
              { to: '/PollForm', label: 'Create Poll', icon: <NoteAddIcon /> },
              { to: '/PollList', label: 'View Polls', icon: <ListAltIcon /> },
            ],
          },
            {
            label: 'Category', // Parent item
            icon: <FolderOpen />,
            children: [
           { to: '/CategoryManagement', label: 'Category Management', icon: <CategoryIcon /> },
             { to: '/LocationManagement', label: 'Location Management', icon: <LocationOnIcon /> },
           

{ to: '/SubCategoryManagement', label: 'SubCategory Management', icon: <SubdirectoryArrowRightIcon />},
            ],
          },
             {
            label: 'Video', // Parent item
            icon: <FolderOpen />,
            children: [
               { to: '/VideoManagement', label: 'Video Management', icon: <VideocamIcon /> }, 
       
          { to: '/AllVideoManagement', label: 'All Video Management', icon: <VideocamIcon /> },
            ],
          },
          
           {
            label: 'Shorts', // Parent item
            icon: <FolderOpen />,
            children: [
                    { to: '/CreateShortadmin', label: 'Create Short', icon: <VideoCallIcon /> },
                   { to: '/MyShortsList', label: 'MyShortsList', icon: <VideoCallIcon /> },
               {to: '/AllShortsManagement', label: 'All Short Management', icon: <AwardIcon /> },
            ],
          },
            {
            label: 'Story', // Parent item
            icon: <FolderOpen />,
            children: [
                    
          { to: '/CreateStoryForm', label: 'CreateStoryForm', icon: <LocalOfferIcon  /> },
          { to: '/AllStoryManagement', label: 'All Story Management', icon: <LocalOfferIcon  /> },
            ],
          },


      
          { to: '/TagManagement', label: 'Tag Management', icon: <TagIcon  /> },
          
          { to: '/CategoryNewsForm', label: 'CategoryNews', icon: <LocalOfferIcon  /> },
        
  
              
               { to: '/AdManagement', label: 'AdManagement', icon: <AwardIcon /> },
               
                // { to: '/CompanyCategory', label: 'CompanyCategory', icon: <LocalOfferIcon  /> },
                
                //   // { to: '/CompanySubCategory', label: 'CompanySubCategory ', icon: <LocalOfferIcon  /> },
                //          { to: '/PendingCompanyProfileUpdatesPage', label: 'CompanyApproval ', icon: <LocalOfferIcon  /> },                    
                  
                //    { to: '/CompanyApproval', label: 'CompanyApproval ', icon: <LocalOfferIcon  /> },
                   
                    
                {
  label: 'Company',
  icon: <LocalOfferIcon />, // optional — tu koi bhi icon use kar sakta hai, e.g., BusinessIcon
  children: [
    { to: '/CompanyCategory', label: 'Company Category', icon: <LocalOfferIcon /> },
    { to: '/CompanySubCategory', label: 'Company Sub Category', icon: <LocalOfferIcon /> },
    { to: '/CompanyApproval', label: 'Company Approval', icon: <LocalOfferIcon /> },
    { to: '/PendingCompanyProfileUpdatesPage', label: 'Pending Company Updates', icon: <LocalOfferIcon /> },
    { to: '/NewsPDFDownloader', label: 'NewsPDFDownloader', icon: <LocalOfferIcon /> },
        { to: '/BulkDeleteNews', label: 'Bulk Delete News', icon: <LocalOfferIcon /> },

     { to: '/LiveNewsManager', label: 'LiveNewsManager', icon: <LocalOfferIcon /> },
     
        
    
  ],
},

        ]






      : role === 'reporter'
      ? [
          { to: '/reporter-dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
          {
            label: 'News',
            icon: <ArticleIcon />,
            children: [
              { to: '/NewsCreationPage', label: 'Create News', icon: <AddBoxIcon /> },
              { to: '/MyNews', label: 'My News', icon: <ArticleOutlinedIcon /> },
            ],
          },


          { to: '/VideoManagementbyReporter', label: 'Video Management', icon: <VideoLibraryIcon /> },
            
              { to: '/MyShorts', label: 'My Shorts', icon: <VideoLibraryIcon /> },
              {to: '/CreateStorybyReporter', label: 'Create Story', icon: <VideoCallIcon /> },
          // {
          //   label: 'Shorts',
          //   icon: <ShortTextIcon />,
          //   children: [
          //     { to: '/CreateShort', label: 'Create Short', icon: <VideoCallIcon /> },
          //     { to: '/MyShorts', label: 'My Shorts', icon: <VideoLibraryIcon /> },
          //   ],
          // },
        ]






      : role === 'superadmin'
      ? [
          { to: '/superadmin-dashboard', label: 'Dashboard', icon: <AdminPanelSettingsIcon /> },
          {
            label: 'Admin Management',
            icon: <ManageAccountsIcon />,
            children: [
              { to: '/Create-admins', label: 'Create Admin', icon: <PersonAddAlt1Icon /> },
              { to: '/manage-admins', label: 'Manage Admins', icon: <PeopleAltIcon /> },
            ],
          },
        ]
      : [];

  const drawerWidth = 240; // Slightly wider for better spacing

  return (
    <Drawer
      variant="permanent" // Always visible on desktop
      open={isOpen} // Controlled by parent for mobile/responsive behavior
      onClose={closeSidebar} // Allows closing on mobile
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: 'border-box',
              backgroundColor: '#dcf2fd', // Light Blue
          color: theme.palette.text.primary,
          borderRight: "1px solid #dcf2fd",
          // borderRight: `1px solid ${theme.palette.divider}`,
          // Hide on small screens unless isOpen is true (controlled by parent)
            overflowY: 'auto',
  '&::-webkit-scrollbar': { display: 'none' },  // ✅ Chrome, Safari, Edge
  '-ms-overflow-style': 'none',                // ✅ IE/Edge
  'scrollbar-width': 'none', 
          [theme.breakpoints.down('md')]: {
            display: isOpen ? 'block' : 'none',
          },
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          variant="h6"
          noWrap
          sx={{
            fontWeight: 'bold',
            color: theme.palette.primary.main,
          }}
        >
          {role === 'admin'
            ? 'Admin Panel'
            : role === 'reporter'
            ? 'Reporter Panel'
            : role === 'superadmin'
            ? 'SuperAdmin Panel'
            : 'Panel'}
        </Typography>
        {/* Close button for mobile */}
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <IconButton onClick={closeSidebar}>
            <MenuOpenIcon />
          </IconButton>
        </Box>
      </Box>

      <Divider />

      <List sx={{ pt: 1 }}>
  {links.map((link) => (
    <SidebarItem
      key={link.to || link.label}
      item={link}
      closeSidebar={closeSidebar}
      openKey={openKey}
      setOpenKey={setOpenKey}
    />
  ))}
</List>

    </Drawer>
  );
};

export default Sidebar;



///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


